<template>
  <div class="flex justify-between items-center gap-5 text-EXPONDO-grey">
    <div class="product__attributes flex items-center">
      <template v-if="sku">
        <meta
          :itemprop="SCHEMA_ITEM_PROP.PRODUCTID"
          :content="sku"
        >
        <ProductAttribute
          :label="$t('Product Number')"
          :value="sku"
          :has-schema="true"
        />
      </template>
      <span
        v-if="model"
        class="mx-2"
      >
        |
      </span>
      <ProductAttribute
        v-if="model"
        :label="$t('Model')"
        :value="model"
      />
    </div>
    <ShareUrl />
  </div>
</template>

<script lang="ts">

import type { ProductVariant } from '~~/types/commercetools';
import {
  getProductAttributesExtended,
} from '~~/helpers/product/getProductAttributesExtended';
import { SCHEMA_ITEM_PROP } from '~~/constants/seo';
import { PRODUCT_ATTRIBUTES } from '~~/constants/products';

export default defineComponent({
  name: 'ProductAttributeWrapper',

  props: {
    product: {
      type: Object as PropType<ProductVariant>,
      required: true,
    },
  },
  setup(props: { product: ProductVariant }) {

    const sku = computed(() => props.product?.sku ?? '');
    const model = computed(() => getProductAttributesExtended(
      props.product,
      {
        attributeNames: [PRODUCT_ATTRIBUTES.MODEL],
      },
    )[PRODUCT_ATTRIBUTES.MODEL]);

    return {
      sku,
      model,
      SCHEMA_ITEM_PROP,
    };
  
  },
});

</script>
